// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

import wixWindow from 'wix-window';

export function html1_viewportEnter(event, $w) {
	//Add your code for this event here: 
}

export function box5_click(event) {
	wixWindow.openLightbox("Meet Accent Video");
}

let fadeOptions = {
  			"duration":   300
  		};

export function box6_mouseIn(event) {
	//Add your code for this event here:
	$w('#text173').show("fade", fadeOptions) 
}

export function box6_mouseOut(event) {
	//Add your code for this event here:
	$w('#text173').hide("fade", fadeOptions) 
}

export function box7_mouseIn(event) {
	//Add your code for this event here:
	$w('#text176').show("fade", fadeOptions)  
}

export function box7_mouseOut(event) {
	//Add your code for this event here:
	$w('#text176').hide("fade", fadeOptions)  
}

export function box9_mouseIn(event) {
	//Add your code for this event here: 
	$w('#text178').show("fade", fadeOptions) 
}

export function box9_mouseOut(event) {
	//Add your code for this event here:
	$w('#text178').hide("fade", fadeOptions)  
}

export function box8_mouseIn(event) {
	//Add your code for this event here: 
	$w('#text168').show("fade", fadeOptions) 
}

export function box8_mouseOut(event) {
	//Add your code for this event here: 
	$w('#text168').hide("fade", fadeOptions) 	
}
